// import config from 'config';
import axios from "axios";
import { getApiRequest, postApiRequest, putApiRequest, deleteApiRequest } from '../_helpers';

const path = '/customer/careplanstep/'

export const carePlanStepService = {
  getAll,
  get,
  post,
  put,
  move,
};

async function getAll(customer_id, deactivated=false) {
  const params = {
    customer_id: customer_id,
    deactivated: deactivated,
  }
  return getApiRequest(path, params)
}

function get(id) {
  return getApiRequest(path + id + '/')
}

function post(data) {
  return postApiRequest(path, data, {})
}

function put(id, data) {
  return putApiRequest(path + id + '/', data, {})
}

function remove(id) {
  return deleteApiRequest(path + id + '/')
}

function move(id, order) {
  const data = {
    'order': order,
  }
  return postApiRequest(path + id + '/move/', data)
}
